import React, { useEffect, useRef, useState } from "react";
//import "./productstable.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPencil,
    faTrash,
    faEye,
} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../../common/Pagination";
import { useDispatch, useSelector } from "react-redux";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from "@mui/material/Button";
import ApprovalTwoToneIcon from '@mui/icons-material/ApprovalTwoTone';
import BlockTwoToneIcon from '@mui/icons-material/BlockTwoTone';
import TimerTwoToneIcon from '@mui/icons-material/TimerTwoTone';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, TextField } from "@mui/material";
import { DataGrid, GridApi, GridColDef, GridValueGetterParams, GridCellParams, gridClasses, GridColumnHeaderParams } from '@mui/x-data-grid';
import { CustomerService } from "../../../service/customers.service";
import { alpha, styled } from '@mui/material/styles';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';
import FileDownloadTwoToneIcon from '@mui/icons-material/FileDownloadTwoTone';
import UploadFileTwoToneIcon from '@mui/icons-material/UploadFileTwoTone';
import { forEach } from "lodash";
import { EnterpriseUsers } from "../../../model/enterprise.model";

// dialog


import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import EnterpriseAccountDetails from "./EnterpriseAccountDetails";
import BrandsList from "../../brands/BrandsList";
import EnterpriseUserDialog from "./EnterpriseUserDialog";
import AddEnterpriseDialog from "./AddEnterpriseDialog";
import BulkAssignSalesRepDialog from "./BulkAssignSalesRepDialog";

function EnterpriseCustomers() {

    const customerService = new CustomerService();

    const [entAccountsData , setEntAccountsData] = useState<any[]>([]);

   

    const navigate = useNavigate();

// dialog 
const [status, setStatus] = useState(1);
const [selectedEntDetails, setSelectedEntDetails] = useState("");


const [trigger, setTrigger] = useState(0);

//



const [open, setOpen] = React.useState(false);

const [openAdd, setOpenAdd] = React.useState(false);

const [openBulkAssign, setOpenBulkAssign] = React.useState(false);

const [openUserist, setOpenUserList] = React.useState(false);

    const [selectedEnt, setSelectedEnt] = useState<any>(null);

    const openUserListDialog = (bIndex: string, action: string) => {

        console.log("qqq : ", " : ", bIndex);

     
        var entDetails =  bIndex; // entAccountsData[Number(bIndex) - 1];
      
      

        setSelectedEnt(entDetails);

        setOpenUserList(true)

        console.log("aaaa ",selectedEnt)
    };


    const toEnterpriseAccountDetails = (bIndex: string, action: string) => {

        console.log("qqqqqqqqqqqqqqqqqqqqqq : " + entAccountsData[Number(bIndex) - 1], " : ", bIndex);

    
        var entDetails = entAccountsData[Number(bIndex) - 1];
        console.log("entDetails" +JSON.stringify(entDetails))
        setSelectedEntDetails(entDetails)
        setOpen(true);
    };

   /* useEffect(() => {

        if (selectedEntDetails){
            setOpen(true);
        }
      }, [selectedEntDetails]); */

    
   
    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Id', width: 70 },
        { field: 'ein', headerName: 'EIN', width: 130 },
        { field: 'name', headerName: 'Name', flex: 1 },
        { field: 'entAlias', headerName: 'Alias Name', width: 130 },
        { field: 'address', headerName: 'Address', flex: 1 },
        { field: 'branch', headerName: 'Branch', flex: 1 },
        { field: 'gst', headerName: 'GST', flex: 1 },
        {
            field: 'statusColumn', headerName: 'Status', flex: 1,
            renderCell: (params) => {
                return <div>
                    {params.value == 'Pending' && (<p style={{ color: "blue" }}>Pending</p>)
                        || params.value == 'Deactive' && (<p style={{ color: "red" }}>Deactive</p>)
                        || params.value == 'Active' && (<p style={{ color: "green" }}>Active</p>)
                    }
                </div>
            }
        },
        { field: 'users', headerName: 'Users', flex: 1 ,
            renderCell: (params) => {
            return <div>
                {<Button   style={{ color: "blue" , fontSize: '12px' }}   
                
                onClick={(e) => openUserListDialog(params.value, "edit")} >View</Button>
                    
                }
            </div>
        }
     
            },

        { field: 'dateC', headerName: 'Created Date', flex: 1 },
        { field: 'dateU', headerName: 'Updated Date', flex: 1 },


        {
            field: "action",
            headerName: "Action",
            sortable: false,
            renderCell: (params) => {
                const onClick = (e: { stopPropagation: () => void; }) => {
                    e.stopPropagation(); // don't select this row after clicking

                    const api: GridApi = params.api;
                    const thisRow: Record<string, GridCellParams> = {};

                    api
                        .getAllColumns()
                        .filter((c: { field: string; }) => c.field !== "__check__" && !!c)
                        .forEach(
                            (c: { field: string | number; }) => (thisRow[c.field] = params.value.getValue(params.id, c.field))
                        );

                };

                return <div>
                    <Button onClick={(e) => toEnterpriseAccountDetails(params.value, "edit")} > <IconButton> <EditTwoToneIcon fontSize="small" /></IconButton></Button>

                </div>
            },
            flex: 1
        }

    ];

    const loadData = () => {

        customerService.enterpriseCustomerAccounts(99).then(data => {
            const res = data.data;
            //console.log('finishesData', res)
            let cnt1 = 0;
            const peopleWithImages = res.map((person: any, index: any) => {
                cnt1 = cnt1 + 1;

                var entUsers = "";
                person.users.forEach((userData: EnterpriseUsers, index1: any) => {
                    //console.log("userData" + userData.username)    
                    entUsers += userData.username + "(" + userData.mobileno + "),"
                })

                var userdata = {"userlist": person.users , "entID": person.entId }
                
                var statusValue = "Pending"
                if (person.status == -1) {
                    statusValue = "Pending";
                } else     if (person.status == 0) {
                    statusValue = "Deactive";
                } else   if (person.status == 1) {
                    statusValue = "Active";
                }
                          
                
                return {
                    ...person,
                    id: person.entId,
                    ein: person.EIN,
                    name: person.entName,
                    address: person.entAddress,
                    branch: person.entBranch,
                    gst: person.entGST,
                    statusColumn: statusValue , 
                    status: person.status,
                    // users: entUsers,
                    users: userdata ,
                    dateC: person.DateC,
                    dateU: person.DateU,
                    action: cnt1,

                };

            });
            setEntAccountsData(peopleWithImages)


        });

    }

    let isLoadDataInit = false;
    useEffect(() => {

        if (!isLoadDataInit) {
            isLoadDataInit = true;
            loadData();
        }

    }, [])

    // CSV export : all enterprises with their assigned salespersons (one row per enterprise-salesperson
    // pair; an enterprise with no salesperson gets a single UNASSIGNED row).
    const [exporting, setExporting] = useState(false);

    const csvEscape = (value: any) => {
        const s = (value === null || value === undefined) ? "" : String(value);
        return '"' + s.replace(/"/g, '""') + '"';
    };

    const downloadEntSalesRepCsv = () => {
        setExporting(true);
        customerService.getEnterpriseSalesRepReport().then(data => {
            if (!data || data.status != 100 || !Array.isArray(data.data)) {
                toast.error("Download failed : " + (data && data.msg ? data.msg : "no response"), {
                    position: toast.POSITION.BOTTOM_CENTER, autoClose: 3000, hideProgressBar: true,
                });
                setExporting(false);
                return;
            }
            const header = ["EIN", "Enterprise Name", "Alias", "Branch", "GST", "Address",
                "Enterprise Status", "Salesperson Name", "Salesperson Mobile", "Salesperson Email", "Salesperson Status"];
            const lines = [header.map(csvEscape).join(",")];
            data.data.forEach((ent: any) => {
                var entStatus = "Pending";
                if (ent.status == 0) { entStatus = "Deactive"; } else if (ent.status == 1) { entStatus = "Active"; }
                const entCols = [ent.ein, ent.entName, ent.entAlias, ent.entBranch, ent.entGST, ent.entAddress, entStatus];
                if (ent.salesreps && ent.salesreps.length > 0) {
                    ent.salesreps.forEach((rep: any) => {
                        lines.push([...entCols, rep.username, rep.mobileno, rep.mailid,
                            rep.repstatus == 1 ? "Active" : "Inactive"].map(csvEscape).join(","));
                    });
                } else {
                    lines.push([...entCols, "UNASSIGNED", "", "", ""].map(csvEscape).join(","));
                }
            });
            // UTF-8 BOM so Excel renders non-ASCII enterprise names correctly
            const blob = new Blob(["\ufeff" + lines.join("\r\n")], { type: "text/csv;charset=utf-8;" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "enterprise_salespersons_" + new Date().toISOString().slice(0, 10) + ".csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            setExporting(false);
        }).catch(() => {
            toast.error("Download failed !!!", {
                position: toast.POSITION.BOTTOM_CENTER, autoClose: 3000, hideProgressBar: true,
            });
            setExporting(false);
        });
    };


    // dialog 

    const handleUserDialogCallBack = () => {
        setOpenUserList(false)
        loadData()
    }

    const handleCallBack = () => {

        setOpen(false);
        loadData();

       /* toast.success("Updated Successfully !!!", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            hideProgressBar: true,
          }); */        
    };

    const ref = useRef();

    const savedata = () => {
        console.log("pooooooo")
        //setTrigger(78)

    };

    const handleListClose = () => {
        console.log("opppppppppppppppppppppppppppppppppp")
        setOpenUserList(false)
    };


    const handleClose = () => {
        console.log("opppppppppppppppppppppppppppppppppp")
        setOpen(false);
    };

    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
    }));

    interface DialogTitleProps {
        id: string;
        children?: React.ReactNode;
        onClose: () => void;
    }

    function BootstrapDialogTitle(props: DialogTitleProps) {
        const { children, onClose, ...other } = props;

        return (
            <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
                {children}
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
        );
    }


    ///


    return (

        <>
            <div >
                <div className="App border card">
                    


                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px', gap: '8px' }}>
                        <Button variant="outlined" startIcon={<FileDownloadTwoToneIcon />} disabled={exporting} onClick={downloadEntSalesRepCsv}>
                            {exporting ? "Preparing..." : "Download Enterprises + Salespersons"}
                        </Button>
                        <Button variant="outlined" startIcon={<UploadFileTwoToneIcon />} onClick={() => setOpenBulkAssign(true)}>
                            Bulk Assign Salespersons
                        </Button>
                        <Button variant="contained" startIcon={<AddCircleOutlineTwoToneIcon />} onClick={() => setOpenAdd(true)}>
                            Add Enterprise
                        </Button>
                    </div>

                    <div style={{ width: '100%' }}>
                        <DataGrid

                            // table customization start
                            sx={{
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    whiteSpace: "break-spaces", lineHeight: 1, fontSize: "13px", fontWeight: "bold",
                                },
                                '& .MuiDataGrid-columnHeader': {
                                    backgroundColor: "#D0D0D0"
                                },
                                '& .Mui-odd': {
                                    textOverflow: "inherit", fontSize: "12px", textAlign: "left"
                                },

                                '& .Mui-even': {
                                    backgroundColor: "#F7f7f7", textOverflow: "inherit", fontSize: "12px", textAlign: "left"

                                },

                                '& .Mui-cellown': {
                                    paddingTop: 0, paddingBottom: 0

                                },

                            }}

                            getCellClassName={(params) => 'Mui-cellown'}
                            getRowClassName={(params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'}
                            autoHeight={true}
                            getRowHeight={() => 'auto'}

                            // table customization


                            rows={entAccountsData}
                            columns={columns}

                            initialState={{
                                pagination: {
                                    paginationModel: { page: 0, pageSize: 10 },
                                },
                            }}
                            pageSizeOptions={[10, 25, 50]}

                        />
                    </div>


                </div>


                <BootstrapDialog
                    fullWidth                    
                    onClose={handleListClose}
                    aria-labelledby="customized-dialog-title"
                    open={openUserist}>

                    <BootstrapDialogTitle id="customized-dialog-title" onClose={handleListClose}>
                        User List
                    </BootstrapDialogTitle>

                    <EnterpriseUserDialog  entDetails={selectedEnt}  callback={handleUserDialogCallBack} ></EnterpriseUserDialog>

                    <DialogActions>
                   
                    </DialogActions>
                </BootstrapDialog>



                <BootstrapDialog
                    fullWidth
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}>

                    <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                        Enterprise Status
                    </BootstrapDialogTitle>

                    <EnterpriseAccountDetails entDetail={selectedEntDetails} hideEntFeature={true} callback={handleCallBack} ></EnterpriseAccountDetails>

                    <DialogActions>
                   
                    </DialogActions>
                </BootstrapDialog>

                <AddEnterpriseDialog open={openAdd} onClose={() => setOpenAdd(false)} callback={loadData} />
                <BulkAssignSalesRepDialog open={openBulkAssign} onClose={() => setOpenBulkAssign(false)} />
                <ToastContainer />
            </div>
        </>

    );
}


export default EnterpriseCustomers;
